// LIBRARIES
import styled from "styled-components";
import { Swiper } from "swiper/react";
import "swiper/css";
import "swiper/css/pagination";
import "swiper/css/navigation";

// MISC
import { COLORS, FONTS } from "constants/styleVariables";
import { Alert } from "@mui/material";

export const SupportContainer = styled.div`
display: flex;
flex-direction: row;
width: 100%;
height: 100%;
`;

export const InputAtomContainer = styled.div`
  width: 400px;
`

export const RightSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  width: 100%;
  height: 767px;
  background-color: #F5F5F5;
  border-radius: 20px;
  // padding: 25px 0 0px 0;
`;

export const LeftSideContainer = styled.div`
  display: flex;
  flex-direction: column;
  min-width: 460px;
  height: 767px;
  background-color: #F5F5F5;
  border-radius: 20px;
  padding: 25px 0;
  margin-right: 24px;
`;

export const ContentWrapper = styled.div`
  display: flex;
  flex-direction: column;
  max-width: auto;
  margin-bottom: 20px;
`;
export const RowWrapper = styled.div`
  display: flex;
  flex-direction: row;
  align-items: flex-end;
  justify-content: space-between;
  @media (max-width: 1800px) {
    display: flex;
    flex-direction: column;
    align-items: center;
  }
`;

export const Subtitle = styled.div`
  font-size: 20px;
  color: ${COLORS.secondaryBlack};
  font-weight: bold;
  font-family: ${FONTS.montserrat};
  margin-right: 20px;
`;
export const Link = styled.text`
  font-size: 18px;
  font-family: ${FONTS.newsharp};
  font-weight: bold;
  color: ${COLORS.cornflowerBlue};
  text-decoration: underline;
  text-decoration-color: ${COLORS.cornflowerBlue};
  cursor: pointer;
`;
export const SubtitlesContainer = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
`;
export const DiscountCards = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  flex-wrap: wrap;
  position: relative;
`;

export const SwiperContainer = styled(Swiper)`
  display: flex;
  flex-direction: row;
  width: 1560px;
  padding-bottom: 20px;

  .swiper-pagination-clickable .swiper-pagination-bullet-active {
    background: ${COLORS.gradientBlueColors};
  }
`;

export const UserName = styled.div`
  font-size: 16px;
  font-weight: bold;
  color: #101010;
  font-family: ${FONTS.newsharp};
  margin-top: 25px;
`;

export const NoContentContainer = styled.div`
  width: 100%;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  font-size: 18px;
  font-weight: bold;
  color: ${COLORS.fifthGray};
  font-family: ${FONTS.poppins};
  margin-top: 30px;
`;

export const LanguageToggleWrapper = styled.div`
  display: flex;
  flex-direction: row;
  width: 100%;
  height: 50px;
  justify-content: center;
  align-items: center;
  border-bottom: 2px solid #EAE8E8;
`;

export const LanguageValue = styled.div`
  font-size: 18px;
  color: ${({ selected }) => selected ? COLORS.newOrange : COLORS.rainbowIndigo};
  font-weight: 600;
  font-family: ${FONTS.poppins};
  text-align: center;
  justify-content: center;
  align-items:center;
  width: 50%;
  cursor: pointer:
  // background-color: green;
`;

export const LanguageValue1 = styled.div`
  font-size: 18px;
  color: ${({ selected }) => selected ? COLORS.newOrange : COLORS.rainbowIndigo};
  font-weight: 600;
  font-family: ${FONTS.poppins};
  text-align: center;
  justify-content: center;
  align-items:center;
  width: 50%;
  margin: 12px 0;
  border-right: 2px solid #EAE8E8;
  cursor: pointer:
  `;

export const AddCategoryWrapper = styled.div`
  width: 100%;
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: flex-end;
  padding-right: 20px;
  margin-top: 40px;
  margin-bottom: 25px;

`;

export const AddCategory = styled.div`
  font-size: 14px;
  color: ${COLORS.rainbowIndigo};
  font-weight: 600;
  font-family: ${FONTS.poppins};
  text-align: center;
  justify-content: center;
  align-items: center;
  cursor: pointer;
  display: flex;
`
export const Category = styled.div`
  width: 100%;
  height: 45px;
  display: flex;
  flex-direction: row;
  justify-content: space-between;
  align-items: center;
  border-bottom: 2px solid #EAE8E8;
  background-color: ${({ selected }) => selected ? 'rgba(41, 52, 98, 0.2)' : 'transparent'};
  // border-top: 2px solid #EAE8E8;
  cursor: pointer;
`;

export const CategoryTitle = styled.div`
  font-size: 18px;
  color: ${COLORS.rainbowIndigo};
  font-weight: 600;
  font-family: ${FONTS.poppins};
  padding-left: 17px;
  border-left: 3px solid #293462;
`;

export const ArrowWrapper = styled.div`
  margin-right: 20px;
  margin-top: 5.5px;
  height: 100%;
  display: flex;
  justify-content: center;
  align-items: center;
  transform: ${({ rotate }) => rotate ? 'rotate(-90deg)' : 'rotate(0)'};
`;

export const Subcategory = styled.div`
  display: flex;
  flex-direction: column;
`;

export const SubcategoryTitle = styled.div`
  font-size: 16px;
  color: ${({ selected }) => selected ? COLORS.newOrange : COLORS.rainbowIndigo};
  font-weight: 600;
  font-family: ${FONTS.poppins};
  padding-left: 40px;
  margin-top: 10px;
  cursor: pointer;
`;

export const Article = styled.div`

`;

export const ArticleTitle = styled.div`
font-size: 14px;
color: ${({ selected }) => selected ? COLORS.newOrange : COLORS.rainbowIndigo};
font-weight: 600;
font-family: ${FONTS.poppins};
padding-left: 100px;
margin-top: 10px;
cursor: pointer;
`;

export const Header = styled.div`
  height: 75px;
  width: 100%;
  border-bottom: 2px solid #EAE8E8;
  display: flex;
  flex-direction: row;
  justify-content: flex-end;
  align-items: center;
`;

export const ArticleWrapper = styled.div`
  width: 100%
  height: 100%;
  padding: 0px 40px 0 40px;
`;

export const ButtonsWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
  margin-bottom: 60px;
  padding-bottom: 5px;
`;

export const ArticleDescriptionWrapper = styled.div`
  display: flex;
  flex-direction: column;
  height: 460px;
  padding-bottom: 20px;
`;

export const ButtonContainer = styled.div`
  width: 169px;
  margin-left: 20px;
  margin-right: 20px;
`;

export const ButtonHeaderContainer = styled.div`
  width: 169px;
  margin-left: 20px;
  margin-right: 20px;
`;

export const ImageContainer = styled.img`
  margin-right: 10px;
  margin-bottom: 2px;
`;

export const EditWrapper = styled.div`
  display: flex;
  flex-direction: row;
  justify-content: center;
  align-items: center;
`;

export const Edit = styled.div`
  font-size: 14px;
  color: ${COLORS.newOrange};
  font-weight: 600;
  font-family: ${FONTS.poppins};
  margin-right: 20px;
  padding-top: 1px;
  cursor: pointer;
  text-decoration: underline;
  z-index: 1000;
`;

export const EditSubcategory = styled.div`
  font-size: 14px;
  color: ${COLORS.newOrange};
  font-weight: 600;
  font-family: ${FONTS.poppins};
  margin-right: 20px;
  padding-top: 1px;
  cursor: pointer;
  text-decoration: underline;
  z-index: 1000;
  margin-top: 10px;
`;

export const EditWrapperSubcategory = styled.div`
  display: flex;
  flex-direction: row;
  align-items: center;
  justify-content: space-between;
`;

export const SuccessAlert = styled(Alert)`
  background-color: ${COLORS.primaryGreen};
`

export const ArrowContainer = styled.img`
  width: 10px;
`